import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { services } from '../../data/services';

export const NavigationMenu = ({ kind, homepage = false, children, style }) => {
  const isServices = kind === 'services';
  const links = isServices
    ? [['all', 'All Services', '/services/'], ...services.map(service => [service.slug, service.title, `/services/${service.slug}/`])]
    : [['subcontractors', 'Subcontractors', '/subcontractors/'], ['careers', 'Careers', '/careers/'], ['login', 'Subcontractor Login', '/subcontractors/login/']];
  const prefix = homepage ? 'home' : 'interior';
  return <DropdownMenu><DropdownMenuTrigger asChild>
    <button type="button" style={style} className={homepage ? 'home-work-menu' : 'navigation-menu-trigger'} data-testid={`${prefix}-nav-${kind}`} aria-label={isServices ? 'Services menu' : 'Work With Us menu'}>
      {children || <>{isServices ? 'Services' : 'Work With Us'}<ChevronDown size={14} aria-hidden="true" /></>}
    </button>
  </DropdownMenuTrigger><DropdownMenuContent align="end" className="homepage-services-menu" sideOffset={6} data-testid={`${prefix}-${kind}-dropdown`}>
    {links.map(([id, title, to]) => <DropdownMenuItem key={id} asChild><Link to={to} data-testid={`${prefix}-${kind}-${id}`}>{title}</Link></DropdownMenuItem>)}
  </DropdownMenuContent></DropdownMenu>;
};